/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { HelpCircle, MessageSquare, Mail } from 'lucide-react';
import selectStyles from './CustomSelect.module.css';
import themeButtonStyles from '../buttons/CloseButton.module.css';

const itemStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 'var(--space-sm)',
  height: '34px',
  padding: '0 var(--space-sm)',
  borderRadius: 'var(--radius-md)',
  color: 'var(--color-text-secondary)',
  textDecoration: 'none',
  fontSize: '0.9rem',
  boxSizing: 'border-box',
  whiteSpace: 'nowrap',
};

export default function HelpMenu({ width = '30px', height = '30px' }) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={wrapperRef} style={{ position: 'relative' }}>
      <button
        type="button"
        className={themeButtonStyles.buttonDelete}
        onClick={() => setIsOpen((prev) => !prev)}
        aria-label={t('nav.help', { defaultValue: 'Aide' })}
        style={{
          background: 'none',
          cursor: 'pointer',
          border: 'none',
          height,
          width,
          padding: 'var(--space-xs)',
          boxSizing: 'border-box',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: 'var(--radius-circle)',
        }}
      >
        <HelpCircle
          className={themeButtonStyles.trash}
          style={{ color: 'var(--visible)' }}
          size={20}
        />
      </button>

      {isOpen && (
        <div
          className={`${selectStyles.scrollableContent} ${selectStyles.dropdown}`}
          style={{
            position: 'absolute',
            bottom: 'calc(100% + 2px)',
            left: 0,
            zIndex: 20,
            // left: '10px',
            minWidth: '220px',
            border: '1px solid var(--color-border)',
            borderRadius: 'var(--radius-lg)',
            boxSizing: 'border-box',
            padding: 'var(--space-sm)',
            background: 'var(--color-bg)',
          }}
        >
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 'var(--space-2xs)',
          }}
          >
            <Link
              to="/feedback/octogrey/octogrey/feedback"
              className={selectStyles.hoverLign}
              onClick={() => setIsOpen(false)}
              style={itemStyle}
            >
              <MessageSquare size={16} />
              {t('nav.giveFeedback', { defaultValue: 'Faire un feedback' })}
            </Link>

            <a
              href="mailto:contact@octogrey.com"
              className={selectStyles.hoverLign}
              onClick={() => setIsOpen(false)}
              style={itemStyle}
            >
              <Mail size={16} />
              {t('nav.contactUs', { defaultValue: 'Nous contacter' })}
            </a>
          </div>
        </div>
      )}
    </div>
  );
}
